import { CheckCircle2, X } from "lucide-react";
import { GREEN } from "../constants";

// Transient success toast pinned to the bottom-right. Auto-dismiss is owned by the caller.
export function Toast({ message, onClose }: { message: string; onClose: () => void }) {
  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-control bg-grey-800 px-5 py-3 text-[14px] text-white shadow-float"
      role="status"
    >
      <CheckCircle2 size={18} color={GREEN} strokeWidth={2} />
      <span>{message}</span>
      <button
        type="button"
        onClick={onClose}
        className="ml-2 text-grey-400 hover:text-white"
        aria-label="close"
      >
        <X size={16} strokeWidth={2} />
      </button>
    </div>
  );
}
